console.log('Custom JS Loaded');
/* ADJUSTED BY CLAUDE: Gorgias chat buttons for content pages (Online Returns, Delivery).
   A link whose href is "#chat-start-return", "#chat-track-order" or "#chat-shipping-enquiry"
   opens the Gorgias chat and jumps to the matching option. If the chat isn't available,
   it falls back to an email to hi@maplestore.com.au with a matching subject.
   Page content can't carry onclick code (Shopify strips it), so this lives here. */
(function () {
  var CHAT_LINKS = {
    'start-return': { label: 'Returns & Refunds', subject: 'Return request' },
    'track-order': { label: 'Track orders', subject: 'Order tracking' },
    'shipping-enquiry': { label: 'Shipping & delivery enquiry', subject: 'Shipping Information Request' }
  };

  function findChatButton(doc, label) {
    var buttons = doc.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if ((b.getAttribute('aria-label') || '').trim() === label || b.textContent.trim() === label) return b;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#chat-"]') : null;
    if (!link) return;
    var cfg = CHAT_LINKS[link.getAttribute('href').slice(6)];
    if (!cfg) return;
    e.preventDefault();

    var gc = window.GorgiasChat;
    if (!gc || typeof gc.open !== 'function') {
      window.location.href = 'mailto:hi@maplestore.com.au?subject=' + encodeURIComponent(cfg.subject);
      return;
    }

    try { gc.setPage('homepage'); } catch (err) {}
    gc.open();

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var frame = document.getElementById('chat-window');
      var doc = null;
      try { doc = frame && frame.contentDocument; } catch (err) {}
      var btn = doc ? findChatButton(doc, cfg.label) : null;
      if (btn) { clearInterval(timer); btn.click(); }
      else if (tries > 40) { clearInterval(timer); }
    }, 100);
  });
})();
/* END ADJUSTED BY CLAUDE */


const galleryDesktopItems = document.querySelectorAll('.product-gallery__media-list-wrapper .product-gallery__media');
const multiColCarousels = document.querySelectorAll('.slider-wrapper');

if(typeof galleryDesktopItems != 'undefined' && galleryDesktopItems != null) {
    let imgArr = [];
    let zoomBtnArr = [];
    
    galleryDesktopItems.forEach((media, index) => {
        imgArr[index] = media.querySelector('img');
        zoomBtnArr[index] = media.querySelector('.product-gallery__zoom button');

        imgArr[index].addEventListener('click', function() {
            zoomBtnArr[index].click();
        });
    });
}

if(typeof multiColCarousels != 'undefined' && multiColCarousels != null) {
    let prevBtns = [];
    let nextBtns = [];
    let slides = [];
    let slidesContainers = [];

    multiColCarousels.forEach(function(carousel, i) {
        slides[i] = carousel.querySelector('.slide');
        slidesContainers[i] = carousel.querySelector('.slides-container');

        prevBtns[i] = carousel.querySelector(".slide-arrow-prev");
        nextBtns[i] = carousel.querySelector(".slide-arrow-next");

        nextBtns[i].addEventListener("click", () => {
            const slideWidth = slides[i].clientWidth;
            let scrollLeft = 0;
            slidesContainers[i].scrollLeft += slideWidth;
            
            if(prevBtns[i].classList.contains('hide')) {
                prevBtns[i].classList.remove('hide');
            }
            
            scrollLeft = slidesContainers[i].scrollLeft + (slideWidth * 2);
            
            console.log(scrollLeft);
            if(scrollLeft >= slidesContainers[i].scrollWidth) {
                nextBtns[i].classList.add('hide');
            }
        });

        prevBtns[i].addEventListener("click", () => {
            const slideWidth = slides[i].clientWidth;
            let scrollLeft = 0;
            
            slidesContainers[i].scrollLeft -= slideWidth;
            
            if(nextBtns[i].classList.contains('hide')) {
                nextBtns[i].classList.remove('hide');
            }            
            scrollLeft = slidesContainers[i].scrollLeft - slideWidth;
            if(scrollLeft <= 0) {
                prevBtns[i].classList.add('hide');
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const readMoreDivs = document.querySelectorAll('.read-more-content');
    let readMoreBtns = [];

    if(readMoreDivs.length > 0) {
        readMoreDivs.forEach(function(el, index) {
            readMoreBtns[index] = el.querySelector('.read-more-content-btn');
            
            readMoreBtns[index].addEventListener('click', function(e) {
                e.preventDefault();
                readMoreDivs[index].classList.toggle("show");
                readMoreBtns[index].style.display = 'none';
            });
        });
    }
});